import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Votes} from "../core/models/models";
import {firstValueFrom} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VoteService {

  constructor(private httpClient: HttpClient) { }

  async putVote(votes: Votes, league: string): Promise<Votes> {
    return firstValueFrom(this.httpClient.post<Votes>(environment.apiUrl +`votes/put/${league}`, votes));
  }

  async evaluateEvent(league: string, uuid: string): Promise<Object>  {
    return firstValueFrom(this.httpClient.post(environment.apiUrl +`admin/evaluate/${league}/${uuid}`, {}));
  }

  async getOwnVotesForEvent(event_uuid: string): Promise<Votes> {
    return firstValueFrom(this.httpClient.get<Votes>(environment.apiUrl + `votes/${event_uuid}`));
  }
}
